.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    font-family: var(--tempest-font-sans);
    width: 100%;
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-medium);
    color: var(--tempest-text);
}

.field {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-md);
    background: var(--tempest-surface);
    transition: border-color var(--tempest-duration-fast, 120ms);
}

.field:focus-within {
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width, 2px)
        var(--tempest-focus-ring-color, var(--tempest-primary));
}

.input {
    flex: 1 1 auto;
    border: 0;
    background: transparent;
    outline: 0;
    color: var(--tempest-text);
    font: inherit;
    font-family: var(--tempest-font-sans);
}

.sm .input {
    padding: 6px 8px;
    font-size: var(--tempest-text-sm);
}

.md .input {
    padding: 8px 12px;
    font-size: var(--tempest-text-md);
}

.lg .input {
    padding: 10px 14px;
    font-size: var(--tempest-text-lg);
}

.toggle {
    flex: 0 0 auto;
    background: none;
    border: 0;
    cursor: pointer;
    padding: 0 12px;
    font-size: 16px;
    color: var(--tempest-text-muted);
}

.toggle:hover {
    color: var(--tempest-text);
}

.error .field {
    border-color: var(--tempest-danger-border, var(--tempest-danger));
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
}

.errorText {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-danger-fg, var(--tempest-danger));
}

.strength {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    font-size: var(--tempest-text-xs);
}

.strengthBar {
    flex: 1 1 auto;
    height: 4px;
    background: var(--tempest-border);
    border-radius: var(--tempest-radius-full);
    overflow: hidden;
}

.strengthBar > span {
    display: block;
    height: 100%;
    transition: width var(--tempest-duration-base, 200ms);
}

.strengthLabel {
    color: var(--tempest-text-muted);
    flex: 0 0 auto;
}

.level0 .strengthBar > span,
.level1 .strengthBar > span {
    background: var(--tempest-danger-solid, var(--tempest-danger));
}

.level2 .strengthBar > span {
    background: var(--tempest-warning-solid, var(--tempest-warning));
}

.level3 .strengthBar > span,
.level4 .strengthBar > span {
    background: var(--tempest-success-solid, var(--tempest-success));
}
